import { NgModule } from '@angular/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { SharedModule } from '@app/shared';

import { PatientRequestsComponent } from './container/patient-requests.component';
import { SearchByPatientComponent } from './search-by-patient/search-by-patient.component';
import { SearchByRequestComponent } from './search-by-request/search-by-request.component';
import { PatientHistoryListComponent } from './history-list/patient-history-list.component';
import { PatientRequestListComponent } from './request-list/patient-request-list.component';
import { PatientRequestDetailComponent } from './request-detail/patient-request-detail.component';
import { PatientDataComponent } from './patient-data/patient-data.component';
import { RequestTestsListComponent } from './request-tests-list/request-tests-list.component';
import { SignaturesComponent } from './signatures/signatures.component';
import { PatientRequestHeaderComponent } from './patient-request-header/patient-request-header.component';
import { RequestMaterialsComponent } from './request-materials/request-materials.component';
import { RequestAntibioticsComponent } from './request-antibiotics/request-antibiotics.component';
import { CenterListComponent } from './components/centers/center-list/center-list.component';
import { CenterDialogComponent } from './components/centers/center-dialog/center-dialog.component';
import { AcumuladosTableViewComponent } from './acumulados-table-view/acumulados-table-view.component';
import { EvolutionChartsViewComponent } from './evolution-charts/evolution-charts-view.component';
import { ViewRequestComponent } from './view-request/view-request.component';
import { AcumuladosSearchDialogComponent } from './acumulados-search-dialog/acumulados-search-dialog.component';
import { PickListModule } from 'primeng/picklist';
import { EpidemiologySearchPanelComponent } from './epidemiology-search-panel/epidemiology-search-panel.component';
import { EpidemiologyTableViewComponent } from './epidemiology-table-view/epidemiology-table-view.component';
import { SensitivityATBViewComponent } from './sensitivity-atb-view/sensitivity-atb-view.component';
import { EpidemiologySearchDialogComponent } from './epidemiology-search-dialog/epidemiology-search-dialog.component';
import { AtbPillsIconComponent } from './atb-pills-icon/atb-pills-icon.component';

@NgModule({
  declarations: [
    PatientRequestsComponent,
    SearchByPatientComponent,
    SearchByRequestComponent,
    PatientRequestListComponent,
    PatientHistoryListComponent,
    PatientRequestDetailComponent,
    PatientDataComponent,
    RequestTestsListComponent,
    SignaturesComponent,
    PatientRequestHeaderComponent,
    RequestMaterialsComponent,
    RequestAntibioticsComponent,
    CenterListComponent,
    CenterDialogComponent,
    AcumuladosTableViewComponent,
    EvolutionChartsViewComponent,
    ViewRequestComponent,
    AcumuladosSearchDialogComponent,
    EpidemiologySearchPanelComponent,
    EpidemiologyTableViewComponent,
    SensitivityATBViewComponent,
    EpidemiologySearchDialogComponent,
    AtbPillsIconComponent,
  ],
  imports: [
    SharedModule,
    PanelModule,
    OverlayPanelModule,
    TooltipModule,
    PickListModule,
  ]
})
export class PatientRequestsModule { }
